import React, { Component, Fragment, PureComponent } from 'react';
import Modal, { ModalContainer } from '../modal';

const Box = () => (
    <div className="box-vip-bet-description-cont">
      <p>VIP-ставка – ставка на любую сумму, которая превышает текущий максимум для выбранного исхода.</p>
      <br />
      <p>Порядок приема VIP-ставки:</p>
      <ul className="ul">
        <li>Добавьте событие в корзину и нажмите галочку VIP-ставка.</li>
        <li>Введите сумму ставки.</li>
        <li>Отправьте запрос на подтверждение ставки. В разделе «Ваши ставки» в запросе будет отмечено как «Ожидает приема».</li>
        <li>Не более чем в течение 8 минут, с момента запроса Клиента, компания принимает решение принять ставку или отклонить.</li>
        <li>В случае, если ставка отклоняется, ставка помечается как «Отклонена» и сохраняется в истории счёта в течение 24 часов, после чего более не отображается.</li>
      </ul>
      <div>
        <div className="box-vip-bet-guide-gif"></div>
      </div>
    </div>
)

export default class VipBox extends PureComponent{
  state = {
    open: false
  }

  handleClick = () => {
    this.setState({open: !this.state.open});
  }

  render(){
      return(
        <div className="fl_l basket-help" >
          <div className="basket-help-ico-new" onClick={this.handleClick}>
            ?
          </div>
          {this.state.open ?
            <ModalContainer>
              <Modal styleModal={{width: '600px'}} show={this.state.open} onCloseModal={this.handleClick} title="VIP-ставка">
                <Box />
              </Modal>
            </ModalContainer> : ''
          }
        </div>
      )
  }
}


// WEBPACK FOOTER //
// ./src/components/basket/vipBox.js